import { OlRateIdInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { OlTeflPrice } from '../../../lib/types/models/ol/tefl-price/ol-tefl-price'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getOlTeflPrice({ id, olId }: OlRateIdInput) {
  return restApiClient
    .url(constructApiUrl(API.ols.getOlTeflPrice.url, { id, olId }))
    .get<OlTeflPrice>()
}
